








import IssueInvoiceAction from "@/actions/IssueInvoiceAction";
import Api from "@/api/Api";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    publishmentOrder: Object as PropType<PublishmentOrder>
  },
  methods: {
    async click() {
      const publishmentOrder = await this.$store.dispatch(
        "loadResource",
        this.publishmentOrder["@id"]
      );

      IssueInvoiceAction(
        publishmentOrder,
        "invoice-" +
          (publishmentOrder.advertisement || {}).formattedAdvertisementId +
          ".pdf"
      );
    }
  }
});
